/**
 * Flavor Accents — floating fruit images on the PDP
 * Mirrors components/product/flavor-accents.tsx
 *
 * Init runs in requestIdleCallback so the 12 decorative nodes don't compete
 * with LCP rendering. Fall back to a small setTimeout for Safari (no rIC).
 */
(function () {
  var container = document.querySelector('[data-pdp-accents]');
  if (!container) return;

  var rIC = window.requestIdleCallback || function (cb) { return setTimeout(cb, 200); };
  rIC(init, { timeout: 2000 });

  function init() {

  /* ---- Image map keyed by flavor ---- */
  var images = {
    Watermelon: [
      container.dataset.watermelona,
      container.dataset.watermelonb,
      container.dataset.watermelonc
    ],
    'Cool Mint': [
      container.dataset.minta,
      container.dataset.mintb,
      container.dataset.mintc
    ],
    'Cucumber Citrus': [
      container.dataset.citrusa,
      container.dataset.citrusb,
      container.dataset.citrusc
    ],
    'Ginger Lime': [
      container.dataset.gingera,
      container.dataset.gingerb,
      container.dataset.gingerc
    ]
  };

  /* ---- Position configs (matches React positions array) ---- */
  var positions = [
    // Top corners — desktop only
    { top: '2%', left: '2%', size: 100, mobile: 0, anim: 'pdp-float-slow', rot: -15 },
    { top: '8%', right: '3%', size: 90, mobile: 0, anim: 'pdp-float-medium', rot: 25 },
    // Left side
    { top: '35%', left: '-2%', size: 80, mobile: 40, anim: 'pdp-float-fast', rot: -30 },
    { top: '55%', left: '-1%', size: 70, mobile: 35, anim: 'pdp-float-medium', rot: 20 },
    { top: '75%', left: '-2%', size: 85, mobile: 0, anim: 'pdp-float-slow', rot: -45 },
    // Right side
    { top: '30%', right: '-2%', size: 75, mobile: 40, anim: 'pdp-spin-slow', rot: 0 },
    { top: '50%', right: '-1%', size: 95, mobile: 45, anim: 'pdp-float-fast', rot: 45 },
    { top: '70%', right: '-2%', size: 80, mobile: 0, anim: 'pdp-float-medium', rot: -20 },
    // Bottom — desktop only
    { bottom: '5%', left: '5%', size: 90, mobile: 0, anim: 'pdp-float-slow', rot: 60 },
    { bottom: '8%', left: '25%', size: 70, mobile: 0, anim: 'pdp-float-fast', rot: -10 },
    { bottom: '3%', right: '25%', size: 85, mobile: 0, anim: 'pdp-float-medium', rot: 30 },
    { bottom: '10%', right: '5%', size: 75, mobile: 0, anim: 'pdp-float-slow', rot: -25 }
  ];

  /* ---- Build accent elements ---- */
  var els = [];

  positions.forEach(function (pos, i) {
    var wrapper = document.createElement('div');
    wrapper.className = 'pdp-accent ' + pos.anim;
    wrapper.style.position = 'absolute';
    wrapper.style.pointerEvents = 'none';
    wrapper.style.zIndex = '1';
    if (pos.top) wrapper.style.top = pos.top;
    if (pos.bottom) wrapper.style.bottom = pos.bottom;
    if (pos.left) wrapper.style.left = pos.left;
    if (pos.right) wrapper.style.right = pos.right;

    var s = pos.mobile > 0 ? pos.mobile : pos.size;
    wrapper.style.width = s + 'px';
    wrapper.style.height = s + 'px';

    if (pos.mobile === 0) {
      wrapper.classList.add('pdp-accent--desktop');
    }

    var inner = document.createElement('div');
    inner.style.width = '100%';
    inner.style.height = '100%';
    inner.style.transform = 'rotate(' + pos.rot + 'deg)';
    inner.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    inner.style.transitionDelay = (i * 50) + 'ms';

    var img = document.createElement('img');
    img.alt = '';
    img.loading = 'lazy';
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.objectFit = 'contain';
    img.style.filter = 'drop-shadow(0 4px 6px rgba(0,0,0,0.15))';

    inner.appendChild(img);
    wrapper.appendChild(inner);
    container.appendChild(wrapper);
    els.push({ wrapper: wrapper, inner: inner, img: img, pos: pos });
  });

  /* ---- Get images for a flavor ---- */
  function getImagesForFlavor(flavor) {
    if (!flavor || flavor === 'Variety Pack' || flavor === '4-Pack Mixed Flavors') {
      // Mix from all flavors
      var mixed = [];
      ['Watermelon', 'Cool Mint', 'Cucumber Citrus', 'Ginger Lime'].forEach(function (f) {
        mixed = mixed.concat(images[f] || []);
      });
      return mixed;
    }
    var set = images[flavor] || [];
    // Repeat to fill all positions
    var out = [];
    while (out.length < positions.length) {
      out = out.concat(set);
    }
    return out;
  }

  /* ---- Update accents when flavor changes ---- */
  function updateAccents(flavor) {
    var srcs = getImagesForFlavor(flavor);

    els.forEach(function (el, i) {
      var src = srcs[i % srcs.length];
      if (!src) {
        el.wrapper.style.display = 'none';
        return;
      }
      // Fade out
      el.inner.style.opacity = '0';
      el.inner.style.transform = 'rotate(' + el.pos.rot + 'deg) scale(0.75)';

      setTimeout(function () {
        el.img.src = src;
        el.wrapper.style.display = '';
        // Fade in
        el.inner.style.opacity = '1';
        el.inner.style.transform = 'rotate(' + el.pos.rot + 'deg) scale(1)';
      }, 350);
    });
  }

  /* ---- Responsive sizing ---- */
  function handleResize() {
    var isDesktop = window.innerWidth >= 768;
    els.forEach(function (el) {
      var s = isDesktop ? el.pos.size : (el.pos.mobile || el.pos.size);
      el.wrapper.style.width = s + 'px';
      el.wrapper.style.height = s + 'px';
    });
  }

  window.addEventListener('resize', handleResize);
  handleResize();

  /* ---- Listen for flavor changes from product-form.js ---- */
  document.addEventListener('pdp:flavor-changed', function (e) {
    updateAccents(e.detail && e.detail.flavor);
  });

  /* ---- Initial render — variety pack ---- */
  updateAccents(null);
  }
})();
